import React from "react";
import { Col, Container, Row } from "reactstrap";
import JobDetailsDescription from "./JobDetailsDescription";
import RightSideContent from "./RightSideContent";
import Section from "./Section";
import { useParams } from "react-router-dom";
import MetaTags from "../../../helpers/Common/MetaTags";
import { getMetaConfig } from "../../../helpers/Common/metaConfig";
import { generateJobPostingSchema } from "../../../helpers/Common/jobPostingSchema";
import { useEffect } from "react";
import { useState } from "react";
import { getSingleJob } from "../../../api/jobs";
import SmallLoader from "../../../helpers/Common/SmallLoader";
import NotFound from "../../../helpers/Common/NotFound";
import { recently_viewed_item_key } from "../../../helpers/common";

const JobDetails = () => {
  const { jobId } = useParams();
  const [details, setJobDetails] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentViewedJobs =
      JSON.parse(localStorage.getItem(recently_viewed_item_key)) || [];

    let newData = [...currentViewedJobs];

    // Check if paramsJob.id is defined and process accordingly.
    if (jobId) {
      const currnetJobId = parseInt(jobId, 10);

      // If jobId is already in newData, removing it.
      newData = newData.filter((id) => id !== currnetJobId);

      // Then unshift jobId to make it the most recent.
      newData.unshift(currnetJobId);
    }

    localStorage.setItem(recently_viewed_item_key, JSON.stringify(newData));
  }, [jobId]); //

  useEffect(() => {
    window.scrollTo({
      top: 100,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    // 1. Check karein ki jobId exist karti hai ya nahi
    if (jobId) {
      setLoading(true); // Loading start karein

      getSingleJob(jobId)
        .then((res) => {
          // 2. Safe check: Kya response ke andar data exist karta hai?
          if (res.data && res.data.success) {
            // res.data.data points to the actual job object (id: 17, jobTitle: "Manager", etc.)
            setJobDetails(res.data.data);
          } else {
            console.error("API success but data not found");
          }
        })
        .catch((err) => {
          console.error("err::", err);
          // Optional: Yahan error message dikha sakte hain
        })
        .finally(() => {
          setLoading(false); // Loading stop karein
        });
    }
  }, [jobId]);

  // Prepare JobPosting schema data
  const jobPostingData = generateJobPostingSchema(details);

  const jobDetailsMeta = getMetaConfig("jobDetails", {
    title: details?.job_title || "Job Details",
    description: details?.job_description
      ? `${details.job_title} - ${details.job_description.substring(0, 150)}...`
      : "View detailed job information including requirements, responsibilities, benefits, and company details.",
    keywords: `${details?.job_title || "job"}, ${
      details?.job_category?.name || "employment"
    }, ${details?.job_location?.name || "career"}, job search, hiring`,
    ogTitle: details?.job_title || "Job Details - JobSeekers Page",
    ogDescription: details?.job_description
      ? `${details.job_title} - ${details.job_description.substring(0, 150)}...`
      : "Get comprehensive job details and apply directly through our platform.",
    jobPosting: jobPostingData,
  });

  return (
    <React.Fragment>
      <MetaTags {...jobDetailsMeta} />
      <Section />
      <section className="section">
        <Container>
          {loading ? (
            <SmallLoader />
          ) : details && details.jobTitle ? ( // <-- Fix: jobTitle use karein
            <Row className="g-4 align-items-start">
              <Col lg={4} xl={4} className="order-2 order-lg-1">
                <div className="sticky-top" style={{ top: "100px" }}>
                  <RightSideContent details={details} />
                </div>
              </Col>

              <Col lg={7} xl={8} className="order-1 order-lg-2">
                <JobDetailsDescription details={details} />
              </Col>
            </Row>
          ) : (
            <NotFound />
          )}
        </Container>
      </section>
    </React.Fragment>
  );
};

export default JobDetails;
